import { faEdit, faRepeat } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import settings from '../../../../settings';
import HeaderbarButton from '../../../components/HeaderbarButton';
import Loader from '../../../components/Loader';
import api from '../../../logic/api';
import DataContainer from '../../../logic/dataContainer';

class OverviewResubmission extends Component {
  constructor(props) {
    super(props);

    let searchString = '';
    if (props.match.params.search) {
      searchString = props.match.params.search;
    }

    this.state = {
      loading: true,
      data: [],
      searchString,
    };
  }

  loadResubmission = () => {
    this.setState({
      loading: true,
    });
    const dataColumns = {
      Typ: 'Resubmission',
    };
    api('get', settings.clientmanagement.dataContainer.getList, {
      parameter: JSON.stringify(dataColumns),
    })
      .then((res) => {
        const filteredClientData = new DataContainer(res);
        this.setState({
          data: filteredClientData.getMany('Entry'),
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
  componentDidMount() {
    this.loadResubmission();
  }

  render() {
    if (this.state.loading) {
      return (
        <div>
          <Loader text="Wiedervorlagen werden geladen..." />
        </div>
      );
    }

    let data = [];
    if (this.state.data.length) {
      data = this.state.data.map((row) => {
        return {
          ...row,
          ResubmissionType: row.ClientGuid ? 'Klient' : 'VN', // To do: change after MW update
        };
      });
    }

    return (
      <>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            <b>Wiedervorlagen (Global)</b>
          </div>
          <div className="Headerbar-buttons">
            <HeaderbarButton icon={faRepeat} onClick={this.loadResubmission}>
              Liste aktualisieren
            </HeaderbarButton>
          </div>
        </div>
        <div className="Page-Content">
          <div className="Buttonbar"></div>
          <ReactTable
            getTrProps={(_, val) => {
              return {
                onClick: () => {
                  return this.props.history.push(
                    `/clientmanagement/detail/resubmission/detail/${val?.original?.Guid}/${val?.original?.ClientGuid}`,
                  );
                },
              };
            }}
            defaultSorted={[
              {
                id: 'DateOfResub',
                desc: true,
              },
            ]}
            data={data}
            pageSize={data.length}
            noDataText="Es wurden keine Wiedervorlagen gefunden."
            columns={[
              {
                accessor: 'DateOfResub',
                Header: 'Datum der Wiedervorlage',
                Cell: ({ original }) => {
                  return (
                    <>{moment(original.DateOfResub).format('DD.MM.YYYY')}</>
                  );
                },
                sortMethod: (a, b) => {
                  return moment(a).isAfter(b);
                },
              },
              {
                accessor: 'Reason',
                Header: 'Grund',
                Cell: ({ original }) => {
                  return <>{original.Reason}</>;
                },
              },
              {
                accessor: 'UpdateUserName',
                Header: 'Mitarbeiter',
                Cell: ({ original }) => {
                  return <>{original.UpdateUserName}</>;
                },
              },
              {
                accessor: 'ResubmissionType',
                Header: 'Typ',
                Cell: ({ original }) => {
                  return <>{original.ResubmissionType}</>;
                },
              },
              {
                accessor: 'Link',
                Header: 'Zur Detailansicht',
                Cell: () => {
                  return (
                    <>
                      <u>Hier klicken</u>&nbsp;
                      <FontAwesomeIcon icon={faEdit} />
                    </>
                  );
                },
              },
            ]}
          />
        </div>
      </>
    );
  }
}

export default withRouter(OverviewResubmission);
